import React from "react";

function useScrollPage(xCoordinates = 0, yCoordinates = 0) {
  React.useEffect(() => {
    window.scrollTo(xCoordinates, yCoordinates);
  }, []);
}

export default useScrollPage;
